import React, { ComponentType, useEffect } from "react";
import useMyMontepioContext from "./components/Context/useMyMontepioContext";

const ProtectedRoute = <P extends object>(WrappedComponent: ComponentType<P>) => {
  const ProtectedRouteComponent = (props: P) => {
    const { isLoggedIn, performLoginRedirect, isMobileAuth } = useMyMontepioContext();

    useEffect(() => {
      if (isMobileAuth) return;

      if (!isLoggedIn) {
        performLoginRedirect();
      }
    }, [isLoggedIn, isMobileAuth, performLoginRedirect]);

    return <WrappedComponent {...props} />;
  };

  ProtectedRouteComponent.displayName = `ProtectedRoute(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;

  return ProtectedRouteComponent;
};

export default ProtectedRoute;
